import { CurrencyPipe } from '@angular/common';
import { Component, inject, input, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CrudService } from '../../core/services/crud.service';
import { getColorClasses } from '../../shared/helpers';
import { ColorTotalComponent } from '../../shared/components/color-total/color-total.component';

@Component({
  selector: 'app-shopping-item',
  imports: [CurrencyPipe, FormsModule, ColorTotalComponent],
  templateUrl: './shopping-item.component.html',
  styles: ``,
})
export class ShoppingItemComponent implements OnInit {
  // private crudService = inject(CrudService);

  itemIsUpdated = output<object>();
  itemIsDeleted = output<string>();

  inputShoppingItem = input<any>({});
  shoppingItem!: any;

  shoppingCart = input<string>('');

  shoppingItemId = '';

  categories!: string;

  quantity: number = 0;

  availableColors: Array<any> = [];

  selectedColor = '';
  selectedWidth = '';

  widths = [];
  roll_count = 0;

  availableWidths: Array<any> = [];

  availableWarehouses: Array<any> = [];

  ngOnInit(): void {
    this.shoppingItem = this.inputShoppingItem();

    this.availableColors = this.shoppingItem.product.possible_colors.map(
      (color: string) => {
        return {
          color: color,
          roll_count: 0,
        };
      }
    );

    this.availableColors.forEach((availableColor: any) => {
      availableColor.roll_count =
        this.shoppingItem.product.inventory_by_combination
          .filter((item: any) => availableColor.color === item.color)
          .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);
    });

    this.availableWarehouses =
      this.shoppingItem.product.possible_warehouses.map((warehouse: string) => {
        return {
          warehouse: warehouse,
          roll_count: 0,
        };
      });

    this.setColor(this.shoppingItem.color);
    this.setWidth(this.shoppingItem.width);
    this.quantity = this.shoppingItem.quantity;

    this.updateWarehouses();
  }

  updateWarehouses() {
    if (!this.selectedColor && !this.selectedWidth) {
      this.availableWarehouses.forEach((availableWarehouse: any) => {
        availableWarehouse.roll_count =
          this.shoppingItem.product.inventory_by_combination
            .filter(
              (item: any) => item.warehouse === availableWarehouse.warehouse
            )
            .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);
      });
    } else if (this.selectedColor && !this.selectedWidth) {
      this.availableWarehouses.forEach((availableWarehouse: any) => {
        availableWarehouse.roll_count =
          this.shoppingItem.product.inventory_by_combination
            .filter(
              (item: any) => item.warehouse === availableWarehouse.warehouse
            )
            .filter((item: any) => item.color === this.selectedColor)
            .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);
      });
    } else if (this.selectedColor && this.selectedWidth) {
      this.availableWarehouses.forEach((availableWarehouse: any) => {
        availableWarehouse.roll_count =
          this.shoppingItem.product.inventory_by_combination
            .filter(
              (item: any) => item.warehouse === availableWarehouse.warehouse
            )
            .filter((item: any) => item.color === this.selectedColor)
            .filter((item: any) => item.width === this.selectedWidth.toString())
            .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);
      });
    }
  }

  setColor(color: any, update?: boolean) {
    this.selectedColor = color;

    this.availableWidths = this.shoppingItem.product.inventory_by_combination
      .filter((item: any) => item.color === this.selectedColor)
      .map((item: any) => {
        return item.width;
      });

    this.setWidth(
      this.shoppingItem.product.inventory_by_combination.filter(
        (item: any) => item.color === this.selectedColor
      )[0].width,
      update
    );

    this.updateWarehouses();

    this.quantity = 1;
  }

  setWidth(width: any, update?: boolean) {
    this.selectedWidth = width;

    this.updateWarehouses();

    this.quantity = 1;

    this.roll_count = this.shoppingItem.product.inventory_by_combination
      .filter((item: any) => item.color === this.selectedColor)
      .filter((item: any) => item.width === this.selectedWidth.toString())
      .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);

    if (update) {
      this.updateShoppingItem();
    }
  }

  takeUnit() {
    if (this.quantity > 1) {
      this.quantity -= 1;

      this.updateShoppingItem();
    }
  }

  addUnit() {
    if (this.quantity < this.roll_count) {
      this.quantity += 1;

      this.updateShoppingItem();
    }
  }

  changeUnits() {
    if (this.quantity < 1) {
      this.quantity = 1;
    } else if (this.quantity.toString().includes('.')) {
      this.quantity = Math.round(this.quantity);
    } else if (this.quantity > this.roll_count) {
      this.quantity = this.roll_count;
    } else {
      return;
    }

    this.updateShoppingItem();
  }

  deleteShoppingItem() {
    this.itemIsDeleted.emit(this.shoppingItem.id);
  }

  updateShoppingItem() {
    if (this.selectedColor && this.selectedWidth && this.quantity >= 0) {
      const updatedShoppingItem = {
        itemId: this.shoppingItem.id,
        productToUpdate: {
          product_id: this.shoppingItem.product.id,
          quantity: this.quantity,
          // uom_reserved: this.shoppingItem.uom_reserved,
          uom_reserved: 'ROLLS',
          unit_price_at_reservation: this.shoppingItem.price_reserved,
          color: this.selectedColor,
          width: this.selectedWidth,
        },
      };

      this.itemIsUpdated.emit(updatedShoppingItem);
    }
  }

  isWidthEnabled(width: any) {
    return this.availableWidths.includes(width.toString());
  }

  getColorClass(color: string) {
    return getColorClasses(color);
  }
}
